const FORMAT_TYPES = {
  ENV_VAR: 'ENV_VAR',
  TREX_SWITCH: 'TREX_SWITCH',
  EMU_RUN_SWITCH: 'EMU_RUN_SWITCH',
  EMU_RUN_BOOL_SWITCH: 'EMU_RUN_BOOL_SWITCH',
};

export const jobConfigurationInitialState = {
  projectSelection: {},
  modelSelection: {},
  targetSelection: {},
  testConfiguration: {
    fields: {
      mainSettings: {
        timeout: {
          value: null, // default null
          mandatory: true, // is mandatory
          error: false,
          fieldFormatting: FORMAT_TYPES.ENV_VAR,
        },
        seed: {
          value: null,
          mandatory: true,
          error: false,
          fieldFormatting: FORMAT_TYPES.TREX_SWITCH,
        },
        interactive: {
          value: false,
          mandatory: false,
          error: false,
          fieldFormatting: FORMAT_TYPES.EMU_RUN_BOOL_SWITCH,
        },
        hsle: {
          value: false,
          mandatory: false,
          error: false,
          fieldFormatting: FORMAT_TYPES.EMU_RUN_BOOL_SWITCH,
        },
      },
    },
    straps: [],
    fuses: [],
  },
};
